import { isLegacyAnnualPlan } from "utils/planUtils";
import { useActiveSubscription } from "routes/data-routes/billing-data/active-subscription";


/**
 * @deprecated The only case when it returns false is when the user is on a legacy annual plan. No real need for this extra hook anymore.
 */
export function useNewBillingPage() {
  const { activeSubscription } = useActiveSubscription();

  const isLegacyAnnualUser = isLegacyAnnualPlan(activeSubscription?.planSlug);
  const isBillingV2Eligible = !isLegacyAnnualUser;

  return {
    isBillingV2Eligible
  };
}
